import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a dots icon (that looks like '...').
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <OrderNotYetSentIcon width={12} />
 */
const OrderNotYetSentIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M39.54,6.4H30.23A6.6,6.6,0,0,0,24,2a6.84,6.84,0,0,0-6.28,4.4H8.49A4.46,4.46,0,0,0,4.1,10.9L4,
                  41.6A4.43,4.43,0,0,0,8.39,46h31a4.43,4.43,0,0,0,4.39-4.4L44,10.9A4.48,4.48,0,0,0,39.54,6.4ZM12,
                  30a4,4,0,1,1,4-4A4,4,0,0,1,12,30ZM21.81,8.6a2.2,2.2,0,1,1,4.33.58,2.18,2.18,0,0,1-1.53,1.55,2.2,
                  2.2,0,0,1-2.8-2.11h0ZM24,30a4,4,0,1,1,4-4A4,4,0,0,1,24,30Zm12,0a4,4,0,1,1,4-4A4,4,0,0,1,36,30`}
        />
    </SvgIcon>
)

OrderNotYetSentIcon.defaultProps = defaultProps

export { OrderNotYetSentIcon }
